module.exports = __webpack_public_path__ + "img/1.cf3a8778.jpg";